import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  initiatives = 'initiatives',
  initiative = 'initiative',
  initiativeSettings = 'initiativeSettings',
}

enum ExternalRoutesIds {
  experimentationPlatformInitiative = 'experimentationPlatformInitiative',
}

// root route
export const initiativesRouteRef = createRouteRef({
  id: RoutesIds.initiatives,
});

export const rootRouteRef = initiativesRouteRef;

// sub-routes within the plugin
export const initiativeRouteRef = createSubRouteRef({
  id: RoutesIds.initiative,
  parent: rootRouteRef,
  path: '/:id',
});

export const initiativeSettingsRouteRef = createSubRouteRef({
  id: RoutesIds.initiativeSettings,
  parent: rootRouteRef,
  path: '/:id/settings',
});

// external routes to other systems (for backward compatibility during migration)
export const experimentationPlatformInitiativeRouteRef = createExternalRouteRef(
  {
    id: 'backstage-experimentation-platform-initiative',
    params: ['id'],
    optional: true,
  },
);

// default routes/routes to be used by other plugins
export const Routes = {
  initiatives: initiativesRouteRef,
  initiative: initiativeRouteRef,
  initiativeSettings: initiativeSettingsRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other systems
  experimentationPlatformInitiative: experimentationPlatformInitiativeRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
